module.exports = __webpack_public_path__ + "img/zmcafe-logo.05f478f2.png";